import { FC } from 'react'
import styles from './bottom.module.scss'
import React from 'react'


const Bottom: FC = () => {
    return (
        <div className={styles.main}>
                <p>COPYRIGHT 2019-2025 © CENTRUM GIMNASTYCZNE OLIMPIC</p>
        </div>
    )
}

export default Bottom